export const HomeDrugIconV2 = (color = "white") => (
  <svg
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    height='100%'
    width='100%'
  >
    <g>
      <g>
        <path d="M257.761,55.137c-1.367-5.35-6.805-8.581-12.163-7.215c-21.566,5.508-39.506,19.041-50.512,38.106    c-2.762,4.783-1.123,10.898,3.66,13.659c1.575,0.909,3.294,1.342,4.99,1.342c3.456,0,6.818-1.794,8.669-5.002    c8.291-14.362,21.837-24.565,38.142-28.728C255.897,65.934,259.127,60.489,257.761,55.137z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M279.573,46.479c-0.15-0.027-0.301-0.052-0.461-0.076c-5.452-0.836-10.519,2.903-11.365,8.353    c-0.844,5.44,2.9,10.54,8.327,11.413c0.578,0.101,1.153,0.149,1.722,0.149c4.739,0,8.948-3.385,9.826-8.212    C288.609,52.672,285.006,47.467,279.573,46.479z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M460.964,302.797c-7.361-2.103-15.322-3.966-23.761-5.578c-0.477-0.124-0.964-0.212-1.457-0.265    c-24.6-4.586-53.165-7.054-82.946-7.054c-16.499,0-32.614,0.767-47.904,2.22l61.789-107.018    c15.51-26.865,19.602-58.267,11.521-88.424c-8.081-30.155-27.327-55.304-54.191-70.813c-55.667-32.138-127.1-13-159.237,42.665    L90.195,197.708c-0.007,0.011-0.015,0.02-0.021,0.031c-0.006,0.011-0.011,0.022-0.017,0.033L15.573,326.955    C0.062,353.82-4.029,385.222,4.051,415.379c8.08,30.155,27.326,55.305,54.191,70.813c17.775,10.262,37.736,15.538,57.982,15.538    c8.53,0,17.112-0.936,25.6-2.832c22.589-5.043,42.897-16.489,58.644-32.805c7.914,9.019,22.642,16.642,44.08,22.766    c29.049,8.299,67.491,12.87,108.248,12.87c40.756,0,79.199-4.571,108.247-12.87c33.809-9.659,50.952-23.036,50.952-39.759v-106.51    c0.002-0.021,0.004-0.04,0.004-0.061C512,325.84,494.829,312.472,460.964,302.797z M352.801,309.898    c15.741,0.001,31.076,0.72,45.589,2.082l-127.03,56.066c-7.536-1.463-14.651-3.134-21.229-5.013    c-29.969-8.563-36.531-17.705-36.531-20.505s6.563-11.942,36.532-20.506C277.497,314.205,313.959,309.898,352.801,309.898z     M182.096,78.53c26.624-46.115,85.803-61.97,131.919-35.346c22.238,12.839,38.175,33.676,44.874,58.671    c6.698,24.996,3.316,51.009-9.522,73.248L280.021,295.21c-0.271,0.042-0.536,0.089-0.807,0.132L112.494,199.08L182.096,78.53z     M193.6,342.477c0,0.019-0.003,0.035-0.003,0.054V443.38c-29.004,38.408-83.428,49.701-125.354,25.493    c-22.239-12.839-38.176-33.676-44.874-58.671c-6.698-24.996-3.315-51.009,9.523-73.248l69.603-120.556l147.233,85.011    c-1.725,0.451-3.429,0.911-5.094,1.387C210.806,312.462,193.637,325.813,193.6,342.477z M492,449.101    c0,2.814-6.548,11.988-36.447,20.53c-27.312,7.803-63.804,12.101-102.754,12.101c-38.95,0-75.443-4.298-102.755-12.101    c-29.9-8.542-36.447-17.716-36.447-20.53v-79.266c7.979,4.649,18.335,8.798,31.039,12.428c7.846,2.242,16.388,4.202,25.448,5.884    c0.44,0.111,0.886,0.194,1.339,0.244c24.243,4.4,52.225,6.768,81.377,6.768c40.647,0,79.061-4.58,108.164-12.895    c12.702-3.629,23.056-7.777,31.036-12.426V449.101z M492,342.531v0.027c-0.041,2.831-6.654,11.94-36.529,20.478    c-27.366,7.817-63.829,12.124-102.671,12.124c-15.063,0-29.757-0.655-43.713-1.904l126.717-55.928    c6.953,1.388,13.548,2.95,19.666,4.698c29.916,8.546,36.506,17.671,36.531,20.489C492.001,342.52,492,342.525,492,342.531z" />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);
